import React, { Component } from 'react';
import { Divider, HTMLTable, Tag, Intent } from '@blueprintjs/core';
import SideMenuWrapper from '../Components/SideMenuWrapper';

export default class Procedures extends Component {
  constructor(props) {
    super(props);
    this.state = {
      procedures: [
        { name: '_AddSilk', db: 'SRO_VT_ACCOUNT', calls: 14890, status: 'VERIFIED' },
        { name: '_AddNewChar', db: 'SRO_VT_SHARD', calls: 10450, status: 'VERIFIED' },
        { name: '_UpdateGuildGold', db: 'SRO_VT_SHARD', calls: 890, status: 'VERIFIED' },
        { name: '_SROFilter_LogExploit', db: 'SRO_VT_LOG', calls: 14210, status: 'VERIFIED' },
      ]
    };
  }

  render() {
    return (
      <SideMenuWrapper>
        <h3 className="display-4 font-italic mb-3" style={{ fontSize: '1.5rem', color: '#182026' }}>
          MS SQL Stored Procedures Execution Log
        </h3>
        <p className="text-muted mb-3" style={{ fontSize: '0.85rem' }}>
          Audit execution metrics and anti-injection security of stored procedures.
        </p>

        <Divider className="mb-4" />

        <HTMLTable bordered condensed striped style={{ width: '100%', fontSize: '0.82rem' }}>
          <thead>
            <tr>
              <th style={{ color: '#182026' }}>Procedure Name</th>
              <th style={{ color: '#182026' }}>Target DB</th>
              <th style={{ color: '#182026' }}>Total Executions</th>
              <th style={{ color: '#182026' }}>Status</th>
            </tr>
          </thead>
          <tbody>
            {this.state.procedures.map((p, i) => (
              <tr key={i}>
                <td className="font-mono font-weight-bold" style={{ color: '#106ba3' }}>{p.name}</td>
                <td className="text-warning font-weight-bold">{p.db}</td>
                <td className="font-mono" style={{ color: '#182026' }}>{p.calls} Calls</td>
                <td><Tag intent={Intent.SUCCESS} round>{p.status}</Tag></td>
              </tr>
            ))}
          </tbody>
        </HTMLTable>
      </SideMenuWrapper>
    );
  }
}
